import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { injectIntl } from 'react-intl';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { BaseComponent } from '../../../components/BaseComponent';
import { List, Row, Cell } from '../../../components/List';
import { selectUsers } from '../selectors';
import { fetchUsersList } from '../actions';
import { VBox } from '../../../components/Box';
import { FormField } from '../../../components/FormFields';
import { DecoratorLabel, Input, RightDecoration } from '../../../components/Input';
import { Button } from '../../../components/Buttons';
import { parseUser } from '../helpers';
import { normalizeSearchString } from '../../../utils/normalizeSearchString';
import { Search } from '../../../components/Icon';
import cn from 'classnames';
import styles from './UserSelectionComponent.module.css';
import ButtonComponent from '../../../containers/App/Components/Button/Button';

const DropdownOptions = styled.ul`
  display: block;
  position: absolute;
  z-index: 10;
  box-sizing: border-box;
  border-radius: 0.375rem;
  top: 40px;
  left: 0;
  width: 100%;
  list-style: none;
  border: solid 1px #eee;
  padding: ${({ show }) => (show ? '0' : '0')};
  background-color: white;
  max-height: 200px;
  overflow: auto;
`;

const DropdownOption = styled.li`
  display: flex;
  align-items: center;
  padding: 6px 10px;
  cursor: pointer;
  background-color: ${({ isSelected }) => (isSelected ? '#86b6fe3b' : 'white')};
  color: ${({ isSelected }) => (isSelected ? 'black' : 'inherited')};

  &:hover {
    background-color: #86b6fe3b;
    color: black;
  }
`;

const STATE = {
  string: null,
  result: null,
};

/* eslint-disable react/prefer-stateless-function */
class UserSelectionComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  get filterCompanyId() {
    return this.props.filter?.companyId;
  }

  componentDidMount() {
    if (this.filterCompanyId) {
      this.search();
    }
  }

  onStringChange(evt) {
    let string = evt.target.value;
    this.setState({ string });
    this._t = !this.props.withoutCompany && this.timeout(this.search.bind(this), 300, this._t);
  }

  search() {
    const search = this.props.withoutCompany ? this.state.string?.toLowerCase() : normalizeSearchString(this.state.string);
    this.props.fetchUsers(0, undefined, search, this.filterCompanyId, result =>
      this.setState({
        result: result.items?.map(parseUser).filter(user => user.id !== this.props.user?.id),
      }),
    );
  }

  render() {
    return (
      <div className={styles.container}>
        <div className={styles.flexContainer}>
          <input
            className={cn("form-control", styles.input)}
            name="string"
            onChange={this.onStringChange.bind(this)}
            value={this.props.value || this.state.string || ''}
            placeholder={this.lblStr('user.selection.placeholder')}
          />
          {/* <div className={styles.button}>
            <ButtonComponent style={'ButtonSoftPrimary'} onClick={this.search.bind(this)}>
              <Search />
            </ButtonComponent>
          </div> */}

          {this.renderResult()}
        </div>
      </div>
    );
  }

  renderResult() {
    if (!this.state.result) return '';

    if (this.props.withoutCompany) {
      return (
        <DropdownOptions>
          <List>
            {this.state.result.map(user => (
              <DropdownOption
                key={user.id}
                onClick={() => {
                  this.props.onSelect?.(user);
                  this.setState({
                    result: '',
                    string: `${user?.name ?? ''} ${user?.surname ?? ''} ${user?.email_address ?? ''}`,
                  });
                }}
              >
                <Cell>
                  {user.name} {user.surname} {user.email_address}
                </Cell>
              </DropdownOption>
            ))}
          </List>
        </DropdownOptions>
      );
    }
    return (
      <DropdownOptions>
        <List>
          {this.state.result.map(user => (
            <DropdownOption key={user.id} onClick={() => this.props.onSelect?.(user)}>
              <Cell>{user.email_address}</Cell>
            </DropdownOption>
          ))}
        </List>
      </DropdownOptions>
    );
  }
}

UserSelectionComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    users: selectUsers(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetchUsers: (offset, limit, string, companyId, callback) => {
      dispatch(fetchUsersList(offset, limit, string, companyId, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const UserSelection = compose(withConnect, withRouter, injectIntl)(UserSelectionComp);
